import { PureComponent, Fragment } from 'react'
import Grid from 'shared/components/search/grid'
import Header from '../containers/header'

export default class Search extends PureComponent {
    render() {
        const { search, user, showTV } = this.props
        const { user: searchUser } = search
        const isUserSearch = searchUser && searchUser.username
        return (
            <Fragment>
                <Header user={user} searchInfo={search} />
                <Grid showTV={!isUserSearch && showTV} />
            </Fragment>
        )
    }
}
